import enums from "../enums";
import APIS from "../service/api.js";
import Service from "../service/index.jsx";

export function getCasinoGames(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.CASINO_GAMES_LOADING, payload: true });
		Service.get("third-party-api", "casinounited/games", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				dispatch({
					type: params.isSearch
						? enums.CASINO_SEARCHED_GAMES_LIST
						: enums.CASINO_GAMES_LIST,
					payload: { ...res.data, isUpdate: !!params.offset },
				});
				if (cb) {
					cb(res?.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				console.log(e);
			});
	};
}
export function getCasinoGame({ id, ...params }, cb) {
	return (dispatch) => {
		dispatch({ type: enums.CASINO_GAMES_LOADING, payload: true });
		Service.get("third-party-api", `casinounited/games/${id}`, { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				dispatch({
					type: enums.CASINO_GAMES_LIST,
					payload: { ...res.data, isUpdate: !!params.offset },
				});
				if (cb) {
					cb(res?.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				console.log(e);
			});
	};
}
export function getMutableGames(games, isLive) {
	return (dispatch) => {
		dispatch({
			type: enums.CASINO_GAMES_LIST,
			payload: { games: games.filter((game) => game.is_live === isLive) },
		});
	};
}

export function initCasinoGame(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		dispatch({ type: enums.CASINO_GAMES_LOADING, payload: true });
		Service.get("third-party-api", "game/launch", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				//dispatch({ type: enums.CASINO_GAMES_INIT_SUCCESS, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
			});
	};
}

export function clearThirdPartyProviders() {
	return (dispatch) => {
		dispatch({ type: enums.CLEAR_3PARTY_PROVIDERS, payload: null });
	};
}

export function getGameTypes(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.CASINO_GAMES_LOADING, payload: true });
		Service.get("third-party-api", "casinounited/gametypes", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				dispatch({ type: enums.CASINO_GAME_TYPE_LIST, payload: res.data });
				if (cb) {
					cb(res);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
				console.log(e);
			});
	};
}

export function getGameProviders(params, cb) {
	return (dispatch) => {
		Service.get("third-party-api", "casinounited/providers", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAME_PROVIDER_LIST, payload: res.data });
				if (cb) {
					cb(res);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};
}
export function getGameAffiliates(params, cb) {
	return (dispatch) => {
		Service.get("third-party-api", "casinounited/games/distinct?field=affiliate", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAME_AFFILIATE_LIST, payload: res.data });
				if (cb) {
					cb(res);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};
}
export function getGameCategories(params, cb) {
	return (dispatch) => {
		Service.get("third-party-api", "casinounited/remotecategories", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_GAME_CATEGORY_LIST, payload: res.data });
				if (cb) {
					cb(res);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};
}

export function getLocalGameCategories(params, isLive, cb) {
	return (dispatch) => {
		Service.get("third-party-api", "casinounited/categories", { params })
			.then((res) => {
				dispatch({
					type: enums.CASINO_GAME_CATEGORY_LIST,
					payload: { ...res.data, isLocalGameCategory: true, isLive },
				});
				if (cb) {
					cb(res);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};
}

export function addAffiliate(params) {
	return Service.post("third-party-api", "affiliate", params);
}

export function getFavoriteGames(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.CASINO_CONTAINER_CONFIGS_LOADING, payload: true });
		Service.get("third-party-api", "casinounited/favorite-games", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_CONTAINER_CONFIGS_LOADING, payload: false });
				dispatch({ type: enums.FAVORITE_GAMES, payload: res.data.games });

				if (cb) cb(res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.CASINO_CONTAINER_CONFIGS_LOADING, payload: false });
				console.error(e);
			});
	};
}

export async function setFavoriteGames(params) {
	return Service.post("third-party-api", "casinounited/favorite-games", params);
}

export function getCasinoContainerConfigs(params) {
	return (dispatch) => {
		dispatch({ type: enums.CASINO_CONTAINER_CONFIGS_LOADING, payload: true });
		Service.get("third-party-api", "casinounited/containers", { params })
			.then((res) => {
				dispatch({ type: enums.CASINO_CONTAINER_CONFIGS_LOADING, payload: false });
				dispatch({ type: enums.CASINO_CONTAINER_CONFIGS, payload: res.data });
			})
			.catch((e) => {
				console.error(e);
				dispatch({ type: enums.CASINO_CONTAINER_CONFIGS_LOADING, payload: false });
			});
	};
}
export const getTVBETUrl = (params, callback) => {
	return Service.get("third-party-api", "tvbetv2/launch", { params })
		.then((res) => {
			callback(res.data);
		})
		.catch((e) => {
			console.error(e);
		});
};
export const getElectroBetsUrl = (params) => {
	return Service.get("third-party-api", "electrobets/launch", { params });
};
export const getDigitainUrl = (params) => {
	return Service.get("third-party-api", "digitain/launch", { params });
};

export function clearCasinoGames(isSearch = false) {
	return (dispatch) => {
		dispatch({
			type: isSearch ? enums.CASINO_SEARCHED_GAMES_LIST : enums.CASINO_GAMES_LIST,
			payload: { isUpdate: false, games: [], count: 0, total: 0 },
		});
	};
}

// Start Unused launch urls

export function getSoftswissLaunchURL() {
	return Service.url("third-party-api-v2", "softswiss/launch");
}

export function getMarkorLaunchURL(params) {
	return Service.get("third-party-api", "markor/launch", { params });
}
export function getOctoLaunchURL(params) {
	return Service.get("third-party-api", "octoplay/launch", { params });
}

export function getFaziLaunchURL(params) {
	return Service.get("third-party-api", "fazi/launch", { params });
}

export function getPNGLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		Service.get("third-party-api", "png/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getEGTLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		Service.get("third-party-api", "egt/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getEGTDigitalLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		Service.get("third-party-api", "egtdigital/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getEvolutionLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api-v2", "evolution/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}
export function getWisecasinoLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api-v2", "wisecasino/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getOneTouchLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api-v2", "onetouch/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getPragmaticLaunchUrl() {
	return Service.url("third-party-api-v2", "pragmaticplay/launch");
}
export function getPascalLaunchUrl(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api", "pascal/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}
export function getRubyLaunchUrl(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api", "rubyplay/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getOneApiLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api", "oneapi/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getEvoGamesLaunchURL(cb) {
	return () => {
		cb(`${APIS["third-party-api"]}/evolution/launch`);
	};
}

export function getBarbarabangLaunchURL({ language, tableId, localGameId }, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api-v2", "barbarabang/launch", {
			params: {
				lang: language,
				tableId: tableId,
				localGameId: localGameId,
			},
		})
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				console.error(e);
			});
	};
}

export function getHub88LaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api", "hub88/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getSmartSoftLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		Service.get("third-party-api", "smartsoft/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

export function getEzugiLaunchURL(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: null });
		dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: true });
		Service.get("third-party-api", "ezugi/launch", { params })
			.then((res) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_SUCCESS, payload: res.data });
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_LOADING, payload: false });
				if (cb) {
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LIVE_CASINO_LAUNCH_ERROR, payload: e });
				dispatch({ type: enums.CASINO_GAMES_LOADING, payload: false });
			});
	};
}

// End Unused launch urls
